module.exports = __webpack_public_path__ + "img/rect4.5368cc45.png";